import naja from 'naja';

export function findAjaxLoaderExt() {
	return naja.extensions.find((element) => {
		return element.name !== undefined && element.name === 'ajax-loader';
	});
}

export function removeNajaExtension(name) {
	let modalExtensionsKey = null;

	if (typeof name === "string") {
		modalExtensionsKey = Object.keys(naja.extensions).find((key) => {
			if (Array.isArray(naja.extensions[key])) {
				let element = naja.extensions[key][0];
				let regex = new RegExp(name);
				return element.toString().match(regex) !== null;
			}

			return false;
		});
	}

	if (modalExtensionsKey !== null && modalExtensionsKey !== undefined) {
		naja.extensions.splice(modalExtensionsKey, 1);
	}
}

export function addMultipleListeners(element, events, handler, useCapture, args){
	if (!element) {
		return;
	}

	if (!(events instanceof Array)) {
		throw 'addMultipleListeners: '+
		'please supply an array of eventstrings '+
		'(like ["click","mouseover"])';
	}
	//create a wrapper to be able to use additional arguments
	let handlerFn = (e) => {
		handler(e, args && args instanceof Array ? args : []);
	};
	events.forEach((event) => {
		element.addEventListener(event, handlerFn, useCapture);
	});
}

export function simulateClick (elem) {
	// Create our event (with options)
	const evt = new MouseEvent('click', {
		bubbles: true,
		cancelable: true,
		view: window
	});

	!elem.dispatchEvent(evt);
}

/**
 *
 * @param {function} func
 * @param {int}      wait milliseconds
 * @param {boolean}  immediate
 * @returns {function(...[*]=)}
 *
 * Example:
 * zipInput.addEventListener('keyup', this.debounce((event) => {
 *   ...
 * }, 500));
 */
export function debounce (func, wait = 800, immediate= false) {
	let timeout;
	return function() {
		let context = this, args = arguments;
		let later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		let callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}

/**
 *
 * @param {string} name
 * @return {string|null}
 */
export function getCookie(name) {
	const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
	if (match) {
		return match[2];
	}

	return null;
}

/**
 *
 * @param {string} name
 * @param {string} value
 * @param {Date|null}date
 */
export function setCookie(name, value, date = null) {
	if (date === null) {
		date = new Date();
		date.setFullYear(date.getFullYear() + 10);
	}

	document.cookie = `${name}=${value}; path=/; expires=` + date.toGMTString();
}

export function changeSelectValue(select, value) {
	select.querySelector('[value="' + value + '"]').selected = true;
}

export function genUuid() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
		const r = Math.random() * 16 | 0,
			v = c === 'x' ? r : (r & 0x3 | 0x8);

		return v.toString(16);
	});
}

/**
 * @return {string|null}
 */
export function findNonce() {
	return document.querySelector('[nonce]') ? document.querySelector('[nonce]').getAttribute('nonce') : null
}

/**
 * Format currency by currency code
 *
 * @param amount {number}
 * @param currency {string} (e.g. CZK, USD, EUR, GBP)
 * @param locale {string,null} (optional)
 * @return {string} currency symbol (e.g. Kč, $, €, £)
 */
export function formatCurrency(amount, currency, locale = null) {
	locale = locale || navigator.language;
	return new Intl.NumberFormat(locale, {style: 'currency', currency, trailingZeroDisplay: 'stripIfInteger'}).format(amount);
}

/**
 * Get currency symbol by currency code
 *
 * @param currency {string} (e.g. CZK, USD, EUR, GBP)
 * @param locale {string,null} (optional)
 * @return {string} currency symbol (e.g. Kč, $, €, £)
 */
export function getCurrencySymbol(currency, locale = null) {
	locale = locale || navigator.language;
	return new Intl.NumberFormat(locale, { style: 'currency', currency })
		.formatToParts(1)
		.find(x => x.type === "currency")
		.value;
}